import React from 'react';
import { Navigate } from 'react-router-dom';
import { getAuth } from 'firebase/auth';
import { app } from '../firebase';
import Loading from './Loading'; // ou seu componente de loading simples

export default function RequireAuth({ children }) {
  const auth = getAuth(app);
  const user = auth.currentUser;

  // Se o Firebase ainda estiver carregando o estado do user, idealmente teríamos um loading aqui.
  // Mas se você usa um observer global, o user já deve estar disponível se veio do Login.
  
  if (!user) {
    // Se não estiver logado, manda pro login
    return <Navigate to="/login" replace />;
  }

  return children;
}